import { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Header from 'containers/Header';
import Table from 'containers/Table';
import { createStructuredSelector } from 'reselect';
import { makeSelectTokenAccessToken } from 'store/oauth/selectors';
import { Redirect, useHistory, useParams } from 'react-router-dom';
import { LiteralHeadersTableTitles, RouteTypes } from 'consts';
import './practice-list.scss';
import { RfUiBreadcrumbs, RfUiModal } from 'renfe-components';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import{
  setLoading,
} from 'store/app/actions';
import {
  getPracticas,
  getPracticasCount,
  getPracticasHorasFormacionInstructorExcel,
  setPracticasCount2,
} from 'store/practicas/actions';
import {
  makeSelectFechaMinimaPractica,
  makeSelectPracticasList,
  makeSelectPracticasListCount,
} from 'store/practicas/selectors';
import {
  parseDate,
  parsePracticeStatus,
  parseTime,
} from 'utils/parsePractices';
import {
  getMonthEndDate,
  getMonthName,
  getMonthStartDate,
} from 'utils/dates-validators';
import { hasAccess } from 'utils/listUtils';
import { userProfile } from 'utils/profilesIndex';
import { useList } from 'hooks/list';
import { InstructorHoursPage } from 'types';
import {
  makeSelectInfoUserProfileSelected,
  makeSelectModalDraftType,
  makeSelectMsgSubmit,
} from 'store/app/selectors';
import {
  getInfoUserProfile,
  setModalDraftType,
  setPracticaReclamadaSeleccionada,
  setPracticaValidadaSeleccionada,
  setMsgSubmit,
} from 'store/app/actions';

const selectors: any = createStructuredSelector({
  access_token: makeSelectTokenAccessToken(),
  msgSubmit: makeSelectMsgSubmit(),
  modalDraftType: makeSelectModalDraftType(),
  profileActive: makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected(),
  practicas: makeSelectPracticasList(),
  practicasCount: makeSelectPracticasListCount(),
  fechaMinimaPractica: makeSelectFechaMinimaPractica(),
  infoUserProfile: makeSelectInfoUserProfileSelected(),
} as any);

const options =
  '[{"label": "Fecha inicio de menor a mayor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "asc"},"active": "true"},{"label": "Fecha inicio de mayor a menor","value": {"order":"FECHA_INI_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de mayor a menor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "desc"},"active": "false"},{"label": "Fecha fin de menor a mayor","value": {"order":"FECHA_FIN_SERVICIO","ascDesc": "asc"},"active": "false"}]';

const listPracticasConstant = 'Listado de prácticas';

const buildStationParagraph = (code: string | null, description: string | null): string => {
  if (!code && !description) {
    return '-';
  }

  const stationCode = code && code !== null ? code : '';
  const stationDescription = description && description !== null ? description : '';

  return `${stationCode} - ${stationDescription}`;
};

const buildUserProfileText = (item: any): string => {
  if (item.usuario_nombre_perfil) {
    return item.usuario_nombre_perfil;
  }

  if (item.usuario_perfil_parsed === 'ALUMNO') {
    return `${item.usuario_perfil_parsed} - ${item.usuario_tipo_ie_parsed}`;
  }

  return item.usuario_perfil_parsed;
};

const buildPracticaLink = (accessToAlumns: boolean, item: any): string =>
  accessToAlumns ? '/listado-alumnos/' + item.ID_CURSO : '';

const buildPracticaCommonFields1 = (item: any, accessToAlumns: boolean): any[] => [
  {
    text: item.ID_CURSO,
    urlLink: buildPracticaLink(accessToAlumns, item),
  },
  {
    text:
      parseDate(item.FECHA_INI_SERVICIO) +
      ' ' +
      parseTime(item.HORA_INI_SERVICIO),
  },
  {
    text:
      parseDate(item.FECHA_FIN_SERVICIO) +
      ' ' +
      parseTime(item.HORA_FIN_SERVICIO),
  },
  {
    text: item.jornadaRelacionada
      ? parseTime(item.jornadaRelacionada[0].HORA_INI_JORNADA)
      : ' ',
  },
  {
    text: item.jornadaRelacionada
      ? parseTime(item.jornadaRelacionada[0].HORA_FIN_JORNADA)
      : ' ',
  },
  {
    text: item.ID_TIPO_PRACTICA !== '' ? item.DESC_PRACTICA : '',
  },
  {
    tooltip: [
      {
        title: 'NºTren: ',
      },
      {
        paragraph: item.NUM_TREN ? item.NUM_TREN : '-',
      },
      {
        title: 'Estación Inicio: ',
      },
      {
        paragraph: buildStationParagraph(
          item.COD_ESTACION_INI,
          item.DESC_ESTACION_INI
        ),
      },
      {
        title: 'Estación Fin: ',
      },
      {
        paragraph: buildStationParagraph(
          item.COD_ESTACION_FIN,
          item.DESC_ESTACION_FIN
        ),
      },
    ],
  },
  { text: item.MIN_PRACTICA },
];

const buildPracticaInfoUser = (item: any): any[] => [
  item.ID_ALUMNO
    ? {
        text: item.ID_ALUMNO + '-' + item.nombre_usuario_parsed,
        tooltip: [
          {
            title: 'Observaciones alumno: ',
          },
          {
            paragraph:
              item.OBSERVACIONES_ALUMNO !== null
                ? item.OBSERVACIONES_ALUMNO
                : 'No hay observaciones del alumno',
          },
        ],
        className: item.ID_ALUMNO ? 'position_icon' : '',
      }
    : {
        text: '',
      },
  {
    text: buildUserProfileText(item),
  },
];

const buildPracticaInstructorField = (item: any): any[] => [
  item.ID_INSTRUCTOR
    ? {
        text: item.ID_INSTRUCTOR
          ? item.ID_INSTRUCTOR + ' - ' + item.NOMBRE_INSTRUCTOR
          : '',
        tooltip: [
          {
            title: 'Observaciones instructor: ',
          },
          {
            paragraph:
              item.OBSERVACIONES_INSTRUCTOR !== null
                ? item.OBSERVACIONES_INSTRUCTOR
                : ' No hay observaciones del instructor',
          },
        ],
        className: item.ID_ALUMNO ? 'position_icon' : '',
      }
    : {
        text: '',
      },
];

const buildPracticaCommonFields2 = (
  item: any,
  canSeeClaimCheckField: boolean,
  canSeeInstructor: boolean,
  practicasCount: number
): any[] => {
  const commonFields2: any[] = [
    {
      text: parsePracticeStatus(item.ID_EST_PRACTICA),
    },
    {
      urlIcon: RouteTypes.DETAIL.replace(':id', String(item?.ID_PRACTICA)),
      ariaLabelIcon: 'Abrir modal',
      label: item.ID_PRACTICA,
    },
  ];

  if ((canSeeClaimCheckField || !canSeeInstructor) && practicasCount !== 0) {
    commonFields2.splice(1, 0, {
      checkRow: 'false',
      label: item.ID_PRACTICA,
      data: item.ID_PRACTICA,
    });
  }

  return commonFields2;
};

const buildPracticaTableData = (
  item: any,
  accessToAlumns: boolean,
  canSeeClaimCheckField: boolean,
  canSeeInstructor: boolean,
  canSeeAlumnInfo: boolean,
  canSeeUserInfo: boolean,
  practicasCount: number
): any[] => {
  let data: any[] = buildPracticaCommonFields1(item, accessToAlumns);

  if (canSeeInstructor || canSeeAlumnInfo) {
    data = [...data, ...buildPracticaInstructorField(item)];
  }

  if (canSeeUserInfo) {
    data = [...data, ...buildPracticaInfoUser(item)];
  }

  return [
    ...data,
    ...buildPracticaCommonFields2(
      item,
      canSeeClaimCheckField,
      canSeeInstructor,
      practicasCount
    ),
  ];
};

const buildPracticaParsed = (
  item: any,
  accessToAlumns: boolean,
  canSeeClaimCheckField: boolean,
  canSeeInstructor: boolean,
  canSeeAlumnInfo: boolean,
  canSeeUserInfo: boolean,
  practicasCount: number
): any => ({
  table: [
    buildPracticaTableData(
      item,
      accessToAlumns,
      canSeeClaimCheckField,
      canSeeInstructor,
      canSeeAlumnInfo,
      canSeeUserInfo,
      practicasCount
    ),
  ],
});

const PracticasInstructor = (): ReactElement => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [checkedPractice] = useState<any[]>([]);
  const [hideClaimButton, setHideClaimButton] = useState(false);
  const [hideValidButton, setHideValidButton] = useState(false);

  const params: InstructorHoursPage = useParams();

  const [itemsOnLeftByProfile, setitemsOnLeftByProfile] = useState(5);

  const links = [
    {
      label: 'Informes de horas formación de instructor',
      link: RouteTypes.REPORT_HOURS_INSTRUCTOR,
      textHelp: 'Informes de horas formación de instructor',
      active: false,
    },
    {
      label: params?.idInstructor,
      link: '#',
      textHelp: params?.idInstructor,
      active: true,
    },
  ];

  const {
    access_token,
    msgSubmit,
    modalDraftType,
    profileActive,
    practicas,
    practicasCount,
  } = useSelector<any, any>(selectors);
  const [list] = useState(true);
  const redirect = (e: any) => {
    history.push(e.detail);
  };

  const defaultEmptyFilter = {
    alumnos: '',
    ascDesc: '',
    cursos: '',
    elemFin: 10,
    elemInicio: 0,
    estados: 'PV,RE,VA',
    instructores: params?.idInstructor || '',
    fechaInicio: getMonthStartDate(
      Number(params?.mes) - 1,
      Number(params?.anyo)
    ).toString(),
    fechaFin: getMonthEndDate(
      Number(params?.mes) - 1,
      Number(params?.anyo)
    ).toString(),
    orden: '',
    sociedades: '',
    isInstructorHours: 'true',
  };

  const [initFilter, setInitFilter] = useState(defaultEmptyFilter);

  /** PROFILE ACCESS */
  const canSeeAlumnExt = hasAccess(profileActive, [
    userProfile.alumno.extBecario,
    userProfile.alumno.extAspirante,
    userProfile.alumno.extMaquinista,
  ]);

  const canSeeInstructor = !hasAccess(profileActive, [userProfile.instructor]);

  const canSeeClaimCheckField = hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.formador,
  ]);

  const canSeeUserInfo = hasAccess(profileActive, [
    userProfile.gestor,
    userProfile.administrador,
    userProfile.instructor,
    userProfile.formador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);

  const accessToAlumns = hasAccess(profileActive, [
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
    userProfile.supervisor,
    userProfile.visualizador,
  ]);

  const canSeeAlumnInfo = hasAccess(profileActive, [
    userProfile.alumno.extBecario,
    userProfile.alumno.extAspirante,
    userProfile.alumno.extMaquinista,
    userProfile.alumno.intBecario,
    userProfile.alumno.intMaquinista,
    userProfile.formador,
    userProfile.gestor,
    userProfile.administrador,
  ]);
  /** end section */

  useEffect(() => {
    document.body.addEventListener('mousemove', () => {
      const aux = document.querySelector(
        'div.ui-lateral-menu > button.ui-lateral-menu__menu-button'
      );
      const isContained = aux?.classList.contains(
        'ui-lateral-menu__menu-button--open'
      );
      if (!isContained) {
        const uls = document.querySelectorAll(
          'div.ui-lateral-menu ul.ui-lateral-menu__sublink-list--open'
        );
        uls.forEach((ul) => {
          ul.classList.remove('ui-lateral-menu__sublink-list--open');
        });
      }
    });
  }, []);

  useEffect(() => {
    // Change filter when params change
    const filter = {
      ...initFilter,
      instructores: params?.idInstructor,
      fechaInicio: getMonthStartDate(
        Number(params?.mes) - 1,
        Number(params?.anyo)
      ).toString(),
      fechaFin: getMonthEndDate(
        Number(params?.mes) - 1,
        Number(params?.anyo)
      ).toString(),
      estados: 'PV,RE,VA',
      pathName: window.location.pathname,
    };
    setInitFilter(filter);
    dispatch(setPracticasCount2(0));
    dispatch(getPracticas(filter));
    dispatch(getPracticasCount(filter));
  }, [params, profileActive, window.location.pathname]);

  const {
    filterRef,
    data,
    setData,
    headers,
    setHeaders,
    handleFilterTable
  } = useList(
      { ...initFilter },
      [],
      {
        action: (filter) => {
          return dispatch(getPracticas(filter));
        },
        headerToAPIMap: {
          'Inicio  Serv.': 'FECHA_INI_SERVICIO',
          'Fin  Serv.': 'FECHA_FIN_SERVICIO',
        },
      },
      (filter) => {
        dispatch(setPracticasCount2(0));
        dispatch(getPracticas(filter));
        dispatch(getPracticasCount(filter));
      },
      async ()=>{
        dispatch(setLoading(true));
        await new Promise(resolve => setTimeout(resolve, 90));
        dispatch(setLoading(false));
     }
    );

  const handleExportExcel = () => {
    dispatch(
      getPracticasHorasFormacionInstructorExcel({
        filter: { ...filterRef.current },
        excelConfig: {
          literals: headers,
          profile: profileActive,
        },
      })
    );
  };

  const handleSelectAll = (data) => {
    const newData = data.map((cell) => {
      return cell.data;
    });

    if (canSeeClaimCheckField) {
      dispatch(setPracticaReclamadaSeleccionada(newData.toString()));
    }
    if (!canSeeInstructor) {
      dispatch(setPracticaValidadaSeleccionada(newData.toString()));
    }
  };

  const handleSelectPractica = (e: any) => {
    const practiceSelected: any = checkedPractice;
    if (e.detail.checked === true) {
      practiceSelected.push(e.detail.data);
    } else {
      const pos = practiceSelected.indexOf(e.detail.data);
      practiceSelected.splice(pos, 1);
    }
    if (canSeeClaimCheckField) {
      dispatch(setPracticaReclamadaSeleccionada(practiceSelected.toString()));
    }
    if (!canSeeInstructor) {
      dispatch(setPracticaValidadaSeleccionada(practiceSelected.toString()));
    }
  };

  useEffect(() => {
    if (!profileActive) {
      return;
    }
    if (canSeeAlumnExt) {
      dispatch(getInfoUserProfile());
    }

    const commonFields1 = [
      { text: LiteralHeadersTableTitles.CURSO },
      {
        text: 'Inicio  Serv.',
        orderBy: true,
        ariaLabelIcon: 'Icono de ordenar',
      },
      {
        text: 'Fin  Serv.',
        orderBy: true,
        ariaLabelIcon: 'Icono de ordenar',
      },
      { text: LiteralHeadersTableTitles.HORA_INI_JORNADA },
      { text: LiteralHeadersTableTitles.HORA_FIN_JORNADA },
      { text: LiteralHeadersTableTitles.TIPO_PRACTICA },
      { text: LiteralHeadersTableTitles.TREN },
    ];

    const minutes = [
      { text: LiteralHeadersTableTitles.MINUTOS },
    ]

    const userInfoFields = [
      { text: LiteralHeadersTableTitles.ID_ALUMNO },
      { text: LiteralHeadersTableTitles.NOMBRE_PERFIL },
    ];

    const instructorFields = [{ text: LiteralHeadersTableTitles.ID_INSTRUCTOR }];

    const commonFields2: any = [
      { text: LiteralHeadersTableTitles.ESTADO, hideResponsive: false },
      {
        text: LiteralHeadersTableTitles.VER,
        hideResponsive: true,
      },
    ];

    if ((canSeeClaimCheckField || !canSeeInstructor) && practicasCount !== 0) {
      commonFields2.splice(1, 0, {
        text: '',
        checkRow: 'false',
        hideResponsive: false,
      });
    }

    let headers: any[] = [...commonFields1, ...minutes];
    let headerExcel: any[] = [...commonFields1, ...minutes];
    if (canSeeInstructor) {
      headers = [...headers, ...instructorFields];
      headerExcel = [...headerExcel, /* ...jornadaInfoFields, */];
    }

    if (canSeeUserInfo) {
      headers = [...headers, ...userInfoFields];
      headerExcel = [...headerExcel];
    }

    headers = [...headers, ...commonFields2];
    headerExcel = [...headerExcel, ...commonFields2];
    setHeaders(headers, headerExcel);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    if (!profileActive) {
      return;
    }

    setHideClaimButton(canSeeClaimCheckField);
    setHideValidButton(!canSeeInstructor);

    const practicasParsed = practicas.map((item) =>
      buildPracticaParsed(
        item,
        accessToAlumns,
        canSeeClaimCheckField,
        canSeeInstructor,
        canSeeAlumnInfo,
        canSeeUserInfo,
        practicasCount
      )
    );

    setData(practicasParsed);
  }, [practicas, profileActive, practicasCount]);

  useEffect(() => {
    if (profileActive) {
      switch (profileActive.ID_PERFIL) {
        case '111':
        case '121':
        case '122':
        case '123':
          setitemsOnLeftByProfile(4);
          break;
        case '211':
        case '311':
        case '411':
        case '511':
          setitemsOnLeftByProfile(5);
          break;
      }
    }
  }, [profileActive]);

  if (!access_token) {
    return <Redirect to={RouteTypes.LOGIN} push />;
  }

  return (
    <>
      <Header />
      <div className="rf-layout-table rf-practice-list">
        <RfUiBreadcrumbs
          links={JSON.stringify(links)}
          onEventChange={(e: any) => {
            history.push(e.detail);
          }}
        ></RfUiBreadcrumbs>
        <h1 className="rf-title rf-title--simple">
          {initFilter.instructores &&
          params.mes &&
          params.anyo &&
          window.location.pathname !== RouteTypes.HOME
            ? 'Listado de prácticas por instructor - ' +
              params?.idInstructor +
              ' - ' +
              getMonthName(Number(params.mes)) +
              ' ' +
              params.anyo
            : listPracticasConstant}
        </h1>
        <Table
          openInit={false}
          redirect={(e: any) => {
            redirect(e);
          }}
          list={list}
          headers={headers}
          data={data}
          orderMobile={true}
          orderOptions={options}
          dataCount={practicasCount}
          handleFilter={handleFilterTable}
          hideAudit={true}
          itemsOnLeft={itemsOnLeftByProfile}
          hideClaim={!hideClaimButton}
          hideValid={!hideValidButton}
          showButtonDetail={true}
          handleExportExcel={handleExportExcel}
          handleCheckAll={handleSelectAll}
          handleCheckPractica={handleSelectPractica}
        />
        <RfUiModal
          title-modal={msgSubmit}
          modalConfirmText="Aceptar"
          id-modal="modalDraft"
          modal-type={modalDraftType}
          onModalClose={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
          onConfirm={(e: any) => {
            dispatch(setMsgSubmit(''));
            dispatch(setModalDraftType(''));
          }}
        ></RfUiModal>
      </div>
    </>
  );
};

export default PracticasInstructor;
